go-overlay {
  --go-overlay-color: rgba(var(--go-token-darkest), 0.8);
  --go-overlay-close-btn-text-color: var(--go-color-lightest);

  @include transition(opacity);

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 0;
  height: 0;
  overflow: auto;
  opacity: 0;
  z-index: var(--layer-important);
  .close-btn-wrapper {
    go-button {
      --go-btn-text-color: var(--go-overlay-close-btn-text-color);
    }
  }
  .overlay-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .overlay-content {
    position: relative;
    visibility: hidden;
  }
  &.active {
    background: var(--go-overlay-color);
    width: 100%;
    height: 100%;
    opacity: 1;
    .overlay-content {
      visibility: visible;
    }
  }
}

@include theme-dark {
  go-overlay {
    --go-overlay-color: rgba(var(--go-token-darkest), 0.8);
    --go-overlay-close-btn-text-color: var(--go-text-color);
  }
}
